import React, { useState } from 'react';
import { Box, Paper, Typography, IconButton, Stack, CircularProgress } from '@mui/material';
import { ArrowBackIosNew, ArrowForwardIos } from '@mui/icons-material';
// --- Các hằng số để xác định loại file ---
const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'svg', 'webp'];
const DOCUMENT_EXTENSIONS = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'];

const FileViewer = ({ files,style={} }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  if (!files || files.length === 0) {
    return <Paper sx={{ p: 2, textAlign: 'center' }}>Không có file để hiển thị.</Paper>;
  }

  const handlePrevious = () => {
    setIsLoading(true);
    setCurrentIndex((prevIndex) => Math.max(prevIndex - 1, 0));
  };

  const handleNext = () => {
    setIsLoading(true);
    setCurrentIndex((prevIndex) => Math.min(prevIndex + 1, files.length - 1));
  };

  const currentFile = files[currentIndex];
  const fileExtension = currentFile.ext;

  const renderFileContent = () => {
    // 1. Hiển thị hình ảnh
    if (IMAGE_EXTENSIONS.includes(fileExtension)) {
      return <img
            src={currentFile.url}
            alt={currentFile.name}
            onLoad={() => setIsLoading(false)}
          />
    }
    // 2. Hiển thị PDF
    const commonIframeProps = {
      title: currentFile.name,
      onLoad: () => setIsLoading(false),
      style: {
        height:"100%",
        width: '100%',
        border: 'none',
      },
    };

    if (fileExtension === 'pdf') {
      const googleDocsUrl = `https://docs.google.com/gview?url=${encodeURIComponent(currentFile.url)}&embedded=true`;
      return <iframe src={googleDocsUrl} {...commonIframeProps} />;
    }
    // 3. Hiển thị tài liệu bằng Office Web Viewer
    if (DOCUMENT_EXTENSIONS.includes(fileExtension)) {
      const officeUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(currentFile.url)}`;
      return <iframe src={officeUrl} {...commonIframeProps} />;
    }
    // 4. Fallback cho các loại file khác
    setIsLoading(false); // Không có gì để load nên tắt loading
    return (
        <Box sx={{p: 4, textAlign: 'center'}}>
            <Typography variant="h6">Không hỗ trợ xem trước</Typography>
            <Typography>Trình duyệt không thể hiển thị loại file này.</Typography>
            <a href={currentFile.url} target="_blank" rel="noopener noreferrer">Tải file về</a>
        </Box>
    );
  };

  return (
    <Box 
      sx={{ 
        width: '100%', 
        height: '100%', 
        display: 'flex', 
        flexDirection: 'column',
        overflow: 'hidden',...style
      }}
    >
      {/* Header: Navigation and Title */}
      {files.length>1 && <Stack 
        direction="row" 
        alignItems="center" 
        justifyContent="space-between" 
        sx={{ p: 1, borderBottom: 1, borderColor: 'divider', flexShrink: 0 }}
      >
        <IconButton onClick={handlePrevious} disabled={currentIndex === 0}>
          <ArrowBackIosNew />
        </IconButton>
        <Typography variant="h6" noWrap sx={{ mx: 2, textAlign: 'center' }}>
          {currentFile.name}
        </Typography>
        <IconButton onClick={handleNext} disabled={currentIndex === files.length - 1}>
          <ArrowForwardIos />
        </IconButton>
      </Stack>}
      {/* Content: File Viewer */}
      <Box sx={{ flex: 1, position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        {isLoading && <CircularProgress sx={{ position: 'absolute' }} />}
        <Box 
            sx={{ 
                width: '100%', 
                height: '100%',
                opacity: isLoading ? 0 : 1,
                position:"relative",
                transition: 'opacity 0.3s'
            }}
        >
            {renderFileContent()}
            <div style={{
                position: 'absolute',
                top: 0,
                right: 0,
                width: '60px',   // Đủ rộng để che nút
                height: '85px',  // Đủ cao để che thanh toolbar chỗ đó
                backgroundColor: "transparent", // Khớp với màu nền toolbar của Google Docs Viewer
                zIndex: 1999990,
                cursor: 'default' // Đổi trỏ chuột để người dùng không nghĩ đây là nút bấm được
            }} />
        </Box>
      </Box>
    </Box>
  );
};

export default FileViewer;